export const isObjEmpty = (obj) => Object.keys(obj).length === 0;
